module.exports = __webpack_public_path__ + "5b8007512579bbcc4f34d45ac6349992.png";